export const allPermissions = [
  'hosts:create',
  'hosts:read',
  'hosts:list',
  'hosts:update',
  'hosts:delete',
  'hosts:enroll',
  'hosts:debug',
  'hosts:block',
  'hosts:unblock',
  'join-keys:create',
  'join-keys:read',
  'join-keys:list',
  'join-keys:update',
  'join-keys:delete',
  'networks:create',
  'networks:read',
  'networks:list',
  'networks:update',
  'networks:delete',
  'roles:create',
  'roles:read',
  'roles:list',
  'roles:update',
  'roles:delete',
  'tags:create',
  'tags:read',
  'tags:list',
  'tags:update',
  'tags:delete',
  'routes:create',
  'routes:read',
  'routes:list',
  'routes:update',
  'routes:delete',
  'endpoint-oidc-providers:create',
  'endpoint-oidc-providers:read',
  'endpoint-oidc-providers:list',
  'endpoint-oidc-providers:update',
  'endpoint-oidc-providers:delete',
  'domains:create',
  'domains:read',
  'domains:list',
  'domains:delete',
  'domains:verify',
  'audit-logs:list',
] as const;

/**
 * Permissions that may be granted to a role-scoped API key.  Mirrors the server's allow-list
 * (data.ScopedKeyAllowedPermissions): the hosts permissions the scope constrains, plus read-only
 * access to the organization-wide objects automation needs to resolve.  The rule denies by
 * default — any permission not listed here cannot be granted to a scoped key.
 */
export const scopedKeyAllowedPermissions = [
  'hosts:create',
  'hosts:read',
  'hosts:list',
  'hosts:update',
  'hosts:delete',
  'hosts:enroll',
  'hosts:debug',
  'hosts:block',
  'hosts:unblock',
  'networks:read',
  'networks:list',
  'roles:read',
  'roles:list',
  'tags:read',
  'tags:list',
  'routes:read',
  'routes:list',
] as const satisfies ReadonlyArray<(typeof allPermissions)[number]>;

const scopedKeyAllowedPermissionSet: ReadonlySet<string> = new Set(scopedKeyAllowedPermissions);

/** Returns true if the permission may be granted to a role-scoped API key. */
export function isAllowedForScopedKey(permission: string) {
  return scopedKeyAllowedPermissionSet.has(permission);
}
